export default __webpack_public_path__ + "10514f4d179aa0b9743e4287ac5b847a.svg";